import { useEffect, useRef } from "react";
import ProctoringSvg from "../../../Svg/ProctoringSvg";
import { ProtectoringIconsName } from "./TrackTimelineDetails";
import useS3FileManagement from "../../../Hooks/useS3FileManagement";
import axios from "../../../api/axios";

const EvidencePopup = ({ data, onClose }) => {
  // console.log("data in EvidancePopup", data);
  const { getPreSignedUrl } = useS3FileManagement();
  const popupRef = useRef();

  const extractTime = (timestamp) => {
    const date = new Date(timestamp);
    return date
      .toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
      .toLowerCase(); // for 'pm' instead of 'PM'
  };

  // console.log(" data ", data);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose(); // Properly close the popup
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const downloadImage = async (filename = "evidence.png", s3Key, hostType) => {
    console.log(
      "download function",
      s3Key,
      "*****",
      hostType,
      "fileName:",
      filename
    );
    if (!s3Key) return;

    const { url } = await getPreSignedUrl(s3Key, hostType, undefined, "GET");
    console.log("url", url);
    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(blobUrl);
  };
  console.log("dataaaaaaaaaaaa:", data);

  return (
    <div
      className="evidance-box"
      ref={popupRef}
      style={{ top: "50%", right: "18%" }}
    >
      <div className="evidence-header">
        <span style={{ display: "flex", gap: "6px" }}>
          {data.issues.map((issue, index) => (
            <ProctoringSvg key={index} type={ProtectoringIconsName(issue)} />
          ))}
        </span>
        <span
          onClick={() => {
            console.log("Data:", data);
            downloadImage("webcam.png", data.s3Key);
            if (data.dpimagePresignedUrl) {
              downloadImage("mobilecam.png", data.s3Key, "DP");
            }
          }}
        >
          <ProctoringSvg type="download" style={{ cursor: "pointer" }} />
        </span>
      </div>

      <div className="evidence-body">
        {/* Webcam image with time */}
        <div className="image-box">
          <img
            src={data.imagePresignedUrl}
            alt="Webcam Snapshot"
            className="proctoring-image"
          />
          <div className="timestamp-overlay">{extractTime(data.timestamp)}</div>
        </div>

        {/* DP (Mobile cam) image with time */}
        {data.dpimagePresignedUrl && (
          <div className="image-box">
            <img
              src={data.dpimagePresignedUrl}
              alt="Mobile Snapshot"
              className="proctoring-image"
            />
            <div className="timestamp-overlay">
              {extractTime(data.dpcreatedTimeStamp)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EvidencePopup;
